<template lang="pug">
  .dashboard
    section
      .max-width
        .breadcrumbs(v-if="isApp")
          ul
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard'}") Dashboard
            li
              span \
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminBoard' : 'PublicBoard', params: { boardSlug: board.slug}}") {{ board.name }}
            li
              span \
            li.selected
              span Create

        .fw--back-button(v-else)
            router-link.button(:to="{ name: 'PublicBoard', params: { boardSlug: board.slug}}")
              font-awesome-icon.icon(:icon="['fas', 'arrow-left']")
              span {{ board.name }}

    section
      .max-width
        .post
          form(@submit.prevent="submit")
            .form-field
              label
                input(
                  v-model="$v.form.name.$model",
                  type="text",
                  placeholder="Title",
                  maxlength="150"
                )
                .error(
                  v-if="$v.form.name.$error && !$v.form.name.required"
                ) Field is required
            .form-field
              label
                textarea(
                  v-model="$v.form.description.$model",
                  placeholder="Description",
                  maxlength="2500"
                )
                .error(
                  v-if="$v.form.description.$error && !$v.form.description.required"
                ) Field is required
            //-div.form-field(v-if="form.attachments")
              .attachment(v-for="attachment in form.attachments")
                img(:src="attachment.url")
            .form-field
              form-upload(
                @uploaded="uploaded",
                endpoint="attachment",
                size="full"
              )
                button.button.upload(type="button")
                  .form-field-upload
                    .empty(v-if="!form.attachments")
                      span Add Image (Optional)
                      font-awesome-icon(
                        :icon="['fad', 'image']",
                        style="--fa-primary-color: #00AC97;--fa-secondary-color: #00AC97;"
                      )
                    .uploaded(v-else)
                      .attachment(v-for="attachment in form.attachments")
                        div
                          span {{ attachment.fileName }}
                        img(:src="attachment.url")

            .form-field
              .col
                button.button.primary-button(type="submit") Create
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'

import FormUpload from '@/components/form/FormUpload'

export default {
  name: 'CreateFeature',
  components: {
    FormUpload
  },
  data () {
    return {
      form: {
        name: '',
        description: '',
        attachments: null
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      }
    }
  },
  beforeMount () {
    this.$store.commit('boards/SELECT_BOARD', this.$route.params.boardSlug)
  },
  computed: {
    ...mapGetters({
      board: 'boards/selected',
    }),
    isApp () {
      //console.log(this.$route)
      return !(this.$route.meta && this.$route.meta.widget)
    }
  },
  methods: {
    uploaded (attachments) {
      this.$set(this.form, 'attachments', [attachments])
    },
    submit (e) {

      /*if (e.key === 'Enter') {
        console.log(e)
        return
      }*/

      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {

        let data = Object.assign({},
          this.form,
          {
            board: this.board._id
          }
        )
        if (data.attachments) {
          data.attachments = data.attachments.map(attachment => attachment._id)
        }

        this.$store.dispatch('features/postFeature', data).then(() => {
          //this.$toast.open('Post Added');

          //this.$store.dispatch('features/getFeatures')
          this.$v.$reset()
          this.form = {
            name: '',
            description: '',
            attachments: null
          }

        }, error => {
          //this.error = error
          //console.log(error)
        })
      }
    },
  }
}

</script>

<style lang="stylus" scoped>
  .post
    .post-header
      h2
        margin-bottom $spacing-2
      p
        color $text-light
        font-size $text-smaller
        margin-bottom $spacing-4

    textarea
      height 150px

  .upload
    //padding $spacing
    width 100%
</style>
